/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root";
import { Route as ReviewRouteRouteImport } from "./routes/review/route";
import { Route as RegistrationRouteRouteImport } from "./routes/registration/route";
import { Route as ManageRouteRouteImport } from "./routes/manage/route";
import { Route as IndexRouteImport } from "./routes/index";
import { Route as ManageIndexRouteImport } from "./routes/manage/index";
import { Route as ReviewRequestIdRouteImport } from "./routes/review/$requestId";
import { Route as RegistrationAuctionIdRouteImport } from "./routes/registration/$auctionId";
import { Route as ManageReviewsRouteRouteImport } from "./routes/manage/reviews/route";
import { Route as ManageAuctionsRouteRouteImport } from "./routes/manage/auctions/route";
import { Route as ManageReviewsIndexRouteImport } from "./routes/manage/reviews/index";
import { Route as ManageAuctionsCreateRouteImport } from "./routes/manage/auctions/create";
import { Route as ManageReviewsRequestsRouteRouteImport } from "./routes/manage/reviews/requests/route";
import { Route as ManageAuctionsAuctionIdRouteRouteImport } from "./routes/manage/auctions/$auctionId/route";
import { Route as ManageReviewsRequestsCreateRouteImport } from "./routes/manage/reviews/requests/create";
import { Route as ManageAuctionsAuctionIdRegistrationUrlRouteImport } from "./routes/manage/auctions/$auctionId/registration-url";
import { Route as ManageAuctionsAuctionIdEditRouteImport } from "./routes/manage/auctions/$auctionId/edit";
import { Route as ManageAuctionsAuctionIdRunRouteRouteImport } from "./routes/manage/auctions/$auctionId/run/route";
import { Route as ManageAuctionsAuctionIdRegistrationsRouteRouteImport } from "./routes/manage/auctions/$auctionId/registrations/route";
import { Route as ManageAuctionsAuctionIdRegistrationsCreateRouteImport } from "./routes/manage/auctions/$auctionId/registrations/create";
import { Route as ManageAuctionsAuctionIdRegistrationsRegistrationIdRouteRouteImport } from "./routes/manage/auctions/$auctionId/registrations/$registrationId/route";
import { Route as ManageAuctionsAuctionIdRegistrationsRegistrationIdEditRouteImport } from "./routes/manage/auctions/$auctionId/registrations/$registrationId/edit";

const ReviewRouteRoute = ReviewRouteRouteImport.update({
  id: "/review",
  path: "/review",
  getParentRoute: () => rootRouteImport,
} as any);
const RegistrationRouteRoute = RegistrationRouteRouteImport.update({
  id: "/registration",
  path: "/registration",
  getParentRoute: () => rootRouteImport,
} as any);
const ManageRouteRoute = ManageRouteRouteImport.update({
  id: "/manage",
  path: "/manage",
  getParentRoute: () => rootRouteImport,
} as any);
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any);
const ManageIndexRoute = ManageIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => ManageRouteRoute,
} as any);
const ReviewRequestIdRoute = ReviewRequestIdRouteImport.update({
  id: "/$requestId",
  path: "/$requestId",
  getParentRoute: () => ReviewRouteRoute,
} as any);
const RegistrationAuctionIdRoute = RegistrationAuctionIdRouteImport.update({
  id: "/$auctionId",
  path: "/$auctionId",
  getParentRoute: () => RegistrationRouteRoute,
} as any);
const ManageReviewsRouteRoute = ManageReviewsRouteRouteImport.update({
  id: "/reviews",
  path: "/reviews",
  getParentRoute: () => ManageRouteRoute,
} as any);
const ManageAuctionsRouteRoute = ManageAuctionsRouteRouteImport.update({
  id: "/auctions",
  path: "/auctions",
  getParentRoute: () => ManageRouteRoute,
} as any);
const ManageReviewsIndexRoute = ManageReviewsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => ManageReviewsRouteRoute,
} as any);
const ManageAuctionsCreateRoute = ManageAuctionsCreateRouteImport.update({
  id: "/create",
  path: "/create",
  getParentRoute: () => ManageAuctionsRouteRoute,
} as any);
const ManageReviewsRequestsRouteRoute =
  ManageReviewsRequestsRouteRouteImport.update({
    id: "/requests",
    path: "/requests",
    getParentRoute: () => ManageReviewsRouteRoute,
  } as any);
const ManageAuctionsAuctionIdRouteRoute =
  ManageAuctionsAuctionIdRouteRouteImport.update({
    id: "/$auctionId",
    path: "/$auctionId",
    getParentRoute: () => ManageAuctionsRouteRoute,
  } as any);
const ManageReviewsRequestsCreateRoute =
  ManageReviewsRequestsCreateRouteImport.update({
    id: "/create",
    path: "/create",
    getParentRoute: () => ManageReviewsRequestsRouteRoute,
  } as any);
const ManageAuctionsAuctionIdRegistrationUrlRoute =
  ManageAuctionsAuctionIdRegistrationUrlRouteImport.update({
    id: "/registration-url",
    path: "/registration-url",
    getParentRoute: () => ManageAuctionsAuctionIdRouteRoute,
  } as any);
const ManageAuctionsAuctionIdEditRoute =
  ManageAuctionsAuctionIdEditRouteImport.update({
    id: "/edit",
    path: "/edit",
    getParentRoute: () => ManageAuctionsAuctionIdRouteRoute,
  } as any);
const ManageAuctionsAuctionIdRunRouteRoute =
  ManageAuctionsAuctionIdRunRouteRouteImport.update({
    id: "/run",
    path: "/run",
    getParentRoute: () => ManageAuctionsAuctionIdRouteRoute,
  } as any);
const ManageAuctionsAuctionIdRegistrationsRouteRoute =
  ManageAuctionsAuctionIdRegistrationsRouteRouteImport.update({
    id: "/registrations",
    path: "/registrations",
    getParentRoute: () => ManageAuctionsAuctionIdRouteRoute,
  } as any);
const ManageAuctionsAuctionIdRegistrationsCreateRoute =
  ManageAuctionsAuctionIdRegistrationsCreateRouteImport.update({
    id: "/create",
    path: "/create",
    getParentRoute: () => ManageAuctionsAuctionIdRegistrationsRouteRoute,
  } as any);
const ManageAuctionsAuctionIdRegistrationsRegistrationIdRouteRoute =
  ManageAuctionsAuctionIdRegistrationsRegistrationIdRouteRouteImport.update({
    id: "/$registrationId",
    path: "/$registrationId",
    getParentRoute: () => ManageAuctionsAuctionIdRegistrationsRouteRoute,
  } as any);
const ManageAuctionsAuctionIdRegistrationsRegistrationIdEditRoute =
  ManageAuctionsAuctionIdRegistrationsRegistrationIdEditRouteImport.update({
    id: "/edit",
    path: "/edit",
    getParentRoute: () =>
      ManageAuctionsAuctionIdRegistrationsRegistrationIdRouteRoute,
  } as any);

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute;
  "/manage": typeof ManageRouteRouteWithChildren;
  "/registration": typeof RegistrationRouteRouteWithChildren;
  "/review": typeof ReviewRouteRouteWithChildren;
  "/manage/auctions": typeof ManageAuctionsRouteRouteWithChildren;
  "/manage/reviews": typeof ManageReviewsRouteRouteWithChildren;
  "/registration/$auctionId": typeof RegistrationAuctionIdRoute;
  "/review/$requestId": typeof ReviewRequestIdRoute;
  "/manage/": typeof ManageIndexRoute;
  "/manage/auctions/$auctionId": typeof ManageAuctionsAuctionIdRouteRouteWithChildren;
  "/manage/reviews/requests": typeof ManageReviewsRequestsRouteRouteWithChildren;
  "/manage/auctions/create": typeof ManageAuctionsCreateRoute;
  "/manage/reviews/": typeof ManageReviewsIndexRoute;
  "/manage/auctions/$auctionId/registrations": typeof ManageAuctionsAuctionIdRegistrationsRouteRouteWithChildren;
  "/manage/auctions/$auctionId/run": typeof ManageAuctionsAuctionIdRunRouteRoute;
  "/manage/auctions/$auctionId/edit": typeof ManageAuctionsAuctionIdEditRoute;
  "/manage/auctions/$auctionId/registration-url": typeof ManageAuctionsAuctionIdRegistrationUrlRoute;
  "/manage/reviews/requests/create": typeof ManageReviewsRequestsCreateRoute;
  "/manage/auctions/$auctionId/registrations/$registrationId": typeof ManageAuctionsAuctionIdRegistrationsRegistrationIdRouteRouteWithChildren;
  "/manage/auctions/$auctionId/registrations/create": typeof ManageAuctionsAuctionIdRegistrationsCreateRoute;
  "/manage/auctions/$auctionId/registrations/$registrationId/edit": typeof ManageAuctionsAuctionIdRegistrationsRegistrationIdEditRoute;
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute;
  "/registration": typeof RegistrationRouteRouteWithChildren;
  "/review": typeof ReviewRouteRouteWithChildren;
  "/manage/auctions": typeof ManageAuctionsRouteRouteWithChildren;
  "/registration/$auctionId": typeof RegistrationAuctionIdRoute;
  "/review/$requestId": typeof ReviewRequestIdRoute;
  "/manage": typeof ManageIndexRoute;
  "/manage/auctions/$auctionId": typeof ManageAuctionsAuctionIdRouteRouteWithChildren;
  "/manage/reviews/requests": typeof ManageReviewsRequestsRouteRouteWithChildren;
  "/manage/auctions/create": typeof ManageAuctionsCreateRoute;
  "/manage/reviews": typeof ManageReviewsIndexRoute;
  "/manage/auctions/$auctionId/registrations": typeof ManageAuctionsAuctionIdRegistrationsRouteRouteWithChildren;
  "/manage/auctions/$auctionId/run": typeof ManageAuctionsAuctionIdRunRouteRoute;
  "/manage/auctions/$auctionId/edit": typeof ManageAuctionsAuctionIdEditRoute;
  "/manage/auctions/$auctionId/registration-url": typeof ManageAuctionsAuctionIdRegistrationUrlRoute;
  "/manage/reviews/requests/create": typeof ManageReviewsRequestsCreateRoute;
  "/manage/auctions/$auctionId/registrations/$registrationId": typeof ManageAuctionsAuctionIdRegistrationsRegistrationIdRouteRouteWithChildren;
  "/manage/auctions/$auctionId/registrations/create": typeof ManageAuctionsAuctionIdRegistrationsCreateRoute;
  "/manage/auctions/$auctionId/registrations/$registrationId/edit": typeof ManageAuctionsAuctionIdRegistrationsRegistrationIdEditRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/": typeof IndexRoute;
  "/manage": typeof ManageRouteRouteWithChildren;
  "/registration": typeof RegistrationRouteRouteWithChildren;
  "/review": typeof ReviewRouteRouteWithChildren;
  "/manage/auctions": typeof ManageAuctionsRouteRouteWithChildren;
  "/manage/reviews": typeof ManageReviewsRouteRouteWithChildren;
  "/registration/$auctionId": typeof RegistrationAuctionIdRoute;
  "/review/$requestId": typeof ReviewRequestIdRoute;
  "/manage/": typeof ManageIndexRoute;
  "/manage/auctions/$auctionId": typeof ManageAuctionsAuctionIdRouteRouteWithChildren;
  "/manage/reviews/requests": typeof ManageReviewsRequestsRouteRouteWithChildren;
  "/manage/auctions/create": typeof ManageAuctionsCreateRoute;
  "/manage/reviews/": typeof ManageReviewsIndexRoute;
  "/manage/auctions/$auctionId/registrations": typeof ManageAuctionsAuctionIdRegistrationsRouteRouteWithChildren;
  "/manage/auctions/$auctionId/run": typeof ManageAuctionsAuctionIdRunRouteRoute;
  "/manage/auctions/$auctionId/edit": typeof ManageAuctionsAuctionIdEditRoute;
  "/manage/auctions/$auctionId/registration-url": typeof ManageAuctionsAuctionIdRegistrationUrlRoute;
  "/manage/reviews/requests/create": typeof ManageReviewsRequestsCreateRoute;
  "/manage/auctions/$auctionId/registrations/$registrationId": typeof ManageAuctionsAuctionIdRegistrationsRegistrationIdRouteRouteWithChildren;
  "/manage/auctions/$auctionId/registrations/create": typeof ManageAuctionsAuctionIdRegistrationsCreateRoute;
  "/manage/auctions/$auctionId/registrations/$registrationId/edit": typeof ManageAuctionsAuctionIdRegistrationsRegistrationIdEditRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/manage"
    | "/registration"
    | "/review"
    | "/manage/auctions"
    | "/manage/reviews"
    | "/registration/$auctionId"
    | "/review/$requestId"
    | "/manage/"
    | "/manage/auctions/$auctionId"
    | "/manage/reviews/requests"
    | "/manage/auctions/create"
    | "/manage/reviews/"
    | "/manage/auctions/$auctionId/registrations"
    | "/manage/auctions/$auctionId/run"
    | "/manage/auctions/$auctionId/edit"
    | "/manage/auctions/$auctionId/registration-url"
    | "/manage/reviews/requests/create"
    | "/manage/auctions/$auctionId/registrations/$registrationId"
    | "/manage/auctions/$auctionId/registrations/create"
    | "/manage/auctions/$auctionId/registrations/$registrationId/edit";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/"
    | "/registration"
    | "/review"
    | "/manage/auctions"
    | "/registration/$auctionId"
    | "/review/$requestId"
    | "/manage"
    | "/manage/auctions/$auctionId"
    | "/manage/reviews/requests"
    | "/manage/auctions/create"
    | "/manage/reviews"
    | "/manage/auctions/$auctionId/registrations"
    | "/manage/auctions/$auctionId/run"
    | "/manage/auctions/$auctionId/edit"
    | "/manage/auctions/$auctionId/registration-url"
    | "/manage/reviews/requests/create"
    | "/manage/auctions/$auctionId/registrations/$registrationId"
    | "/manage/auctions/$auctionId/registrations/create"
    | "/manage/auctions/$auctionId/registrations/$registrationId/edit";
  id:
    | "__root__"
    | "/"
    | "/manage"
    | "/registration"
    | "/review"
    | "/manage/auctions"
    | "/manage/reviews"
    | "/registration/$auctionId"
    | "/review/$requestId"
    | "/manage/"
    | "/manage/auctions/$auctionId"
    | "/manage/reviews/requests"
    | "/manage/auctions/create"
    | "/manage/reviews/"
    | "/manage/auctions/$auctionId/registrations"
    | "/manage/auctions/$auctionId/run"
    | "/manage/auctions/$auctionId/edit"
    | "/manage/auctions/$auctionId/registration-url"
    | "/manage/reviews/requests/create"
    | "/manage/auctions/$auctionId/registrations/$registrationId"
    | "/manage/auctions/$auctionId/registrations/create"
    | "/manage/auctions/$auctionId/registrations/$registrationId/edit";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  ManageRouteRoute: typeof ManageRouteRouteWithChildren;
  RegistrationRouteRoute: typeof RegistrationRouteRouteWithChildren;
  ReviewRouteRoute: typeof ReviewRouteRouteWithChildren;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/review": {
      id: "/review";
      path: "/review";
      fullPath: "/review";
      preLoaderRoute: typeof ReviewRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/registration": {
      id: "/registration";
      path: "/registration";
      fullPath: "/registration";
      preLoaderRoute: typeof RegistrationRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/manage": {
      id: "/manage";
      path: "/manage";
      fullPath: "/manage";
      preLoaderRoute: typeof ManageRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/": {
      id: "/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/manage/": {
      id: "/manage/";
      path: "/";
      fullPath: "/manage/";
      preLoaderRoute: typeof ManageIndexRouteImport;
      parentRoute: typeof ManageRouteRoute;
    };
    "/review/$requestId": {
      id: "/review/$requestId";
      path: "/$requestId";
      fullPath: "/review/$requestId";
      preLoaderRoute: typeof ReviewRequestIdRouteImport;
      parentRoute: typeof ReviewRouteRoute;
    };
    "/registration/$auctionId": {
      id: "/registration/$auctionId";
      path: "/$auctionId";
      fullPath: "/registration/$auctionId";
      preLoaderRoute: typeof RegistrationAuctionIdRouteImport;
      parentRoute: typeof RegistrationRouteRoute;
    };
    "/manage/reviews": {
      id: "/manage/reviews";
      path: "/reviews";
      fullPath: "/manage/reviews";
      preLoaderRoute: typeof ManageReviewsRouteRouteImport;
      parentRoute: typeof ManageRouteRoute;
    };
    "/manage/auctions": {
      id: "/manage/auctions";
      path: "/auctions";
      fullPath: "/manage/auctions";
      preLoaderRoute: typeof ManageAuctionsRouteRouteImport;
      parentRoute: typeof ManageRouteRoute;
    };
    "/manage/reviews/": {
      id: "/manage/reviews/";
      path: "/";
      fullPath: "/manage/reviews/";
      preLoaderRoute: typeof ManageReviewsIndexRouteImport;
      parentRoute: typeof ManageReviewsRouteRoute;
    };
    "/manage/auctions/create": {
      id: "/manage/auctions/create";
      path: "/create";
      fullPath: "/manage/auctions/create";
      preLoaderRoute: typeof ManageAuctionsCreateRouteImport;
      parentRoute: typeof ManageAuctionsRouteRoute;
    };
    "/manage/reviews/requests": {
      id: "/manage/reviews/requests";
      path: "/requests";
      fullPath: "/manage/reviews/requests";
      preLoaderRoute: typeof ManageReviewsRequestsRouteRouteImport;
      parentRoute: typeof ManageReviewsRouteRoute;
    };
    "/manage/auctions/$auctionId": {
      id: "/manage/auctions/$auctionId";
      path: "/$auctionId";
      fullPath: "/manage/auctions/$auctionId";
      preLoaderRoute: typeof ManageAuctionsAuctionIdRouteRouteImport;
      parentRoute: typeof ManageAuctionsRouteRoute;
    };
    "/manage/reviews/requests/create": {
      id: "/manage/reviews/requests/create";
      path: "/create";
      fullPath: "/manage/reviews/requests/create";
      preLoaderRoute: typeof ManageReviewsRequestsCreateRouteImport;
      parentRoute: typeof ManageReviewsRequestsRouteRoute;
    };
    "/manage/auctions/$auctionId/registration-url": {
      id: "/manage/auctions/$auctionId/registration-url";
      path: "/registration-url";
      fullPath: "/manage/auctions/$auctionId/registration-url";
      preLoaderRoute: typeof ManageAuctionsAuctionIdRegistrationUrlRouteImport;
      parentRoute: typeof ManageAuctionsAuctionIdRouteRoute;
    };
    "/manage/auctions/$auctionId/edit": {
      id: "/manage/auctions/$auctionId/edit";
      path: "/edit";
      fullPath: "/manage/auctions/$auctionId/edit";
      preLoaderRoute: typeof ManageAuctionsAuctionIdEditRouteImport;
      parentRoute: typeof ManageAuctionsAuctionIdRouteRoute;
    };
    "/manage/auctions/$auctionId/run": {
      id: "/manage/auctions/$auctionId/run";
      path: "/run";
      fullPath: "/manage/auctions/$auctionId/run";
      preLoaderRoute: typeof ManageAuctionsAuctionIdRunRouteRouteImport;
      parentRoute: typeof ManageAuctionsAuctionIdRouteRoute;
    };
    "/manage/auctions/$auctionId/registrations": {
      id: "/manage/auctions/$auctionId/registrations";
      path: "/registrations";
      fullPath: "/manage/auctions/$auctionId/registrations";
      preLoaderRoute: typeof ManageAuctionsAuctionIdRegistrationsRouteRouteImport;
      parentRoute: typeof ManageAuctionsAuctionIdRouteRoute;
    };
    "/manage/auctions/$auctionId/registrations/create": {
      id: "/manage/auctions/$auctionId/registrations/create";
      path: "/create";
      fullPath: "/manage/auctions/$auctionId/registrations/create";
      preLoaderRoute: typeof ManageAuctionsAuctionIdRegistrationsCreateRouteImport;
      parentRoute: typeof ManageAuctionsAuctionIdRegistrationsRouteRoute;
    };
    "/manage/auctions/$auctionId/registrations/$registrationId": {
      id: "/manage/auctions/$auctionId/registrations/$registrationId";
      path: "/$registrationId";
      fullPath: "/manage/auctions/$auctionId/registrations/$registrationId";
      preLoaderRoute: typeof ManageAuctionsAuctionIdRegistrationsRegistrationIdRouteRouteImport;
      parentRoute: typeof ManageAuctionsAuctionIdRegistrationsRouteRoute;
    };
    "/manage/auctions/$auctionId/registrations/$registrationId/edit": {
      id: "/manage/auctions/$auctionId/registrations/$registrationId/edit";
      path: "/edit";
      fullPath: "/manage/auctions/$auctionId/registrations/$registrationId/edit";
      preLoaderRoute: typeof ManageAuctionsAuctionIdRegistrationsRegistrationIdEditRouteImport;
      parentRoute: typeof ManageAuctionsAuctionIdRegistrationsRegistrationIdRouteRoute;
    };
  }
}

interface ManageAuctionsAuctionIdRegistrationsRegistrationIdRouteRouteChildren {
  ManageAuctionsAuctionIdRegistrationsRegistrationIdEditRoute: typeof ManageAuctionsAuctionIdRegistrationsRegistrationIdEditRoute;
}

const ManageAuctionsAuctionIdRegistrationsRegistrationIdRouteRouteChildren: ManageAuctionsAuctionIdRegistrationsRegistrationIdRouteRouteChildren =
  {
    ManageAuctionsAuctionIdRegistrationsRegistrationIdEditRoute:
      ManageAuctionsAuctionIdRegistrationsRegistrationIdEditRoute,
  };

const ManageAuctionsAuctionIdRegistrationsRegistrationIdRouteRouteWithChildren =
  ManageAuctionsAuctionIdRegistrationsRegistrationIdRouteRoute._addFileChildren(
    ManageAuctionsAuctionIdRegistrationsRegistrationIdRouteRouteChildren,
  );

interface ManageAuctionsAuctionIdRegistrationsRouteRouteChildren {
  ManageAuctionsAuctionIdRegistrationsRegistrationIdRouteRoute: typeof ManageAuctionsAuctionIdRegistrationsRegistrationIdRouteRouteWithChildren;
  ManageAuctionsAuctionIdRegistrationsCreateRoute: typeof ManageAuctionsAuctionIdRegistrationsCreateRoute;
}

const ManageAuctionsAuctionIdRegistrationsRouteRouteChildren: ManageAuctionsAuctionIdRegistrationsRouteRouteChildren =
  {
    ManageAuctionsAuctionIdRegistrationsRegistrationIdRouteRoute:
      ManageAuctionsAuctionIdRegistrationsRegistrationIdRouteRouteWithChildren,
    ManageAuctionsAuctionIdRegistrationsCreateRoute:
      ManageAuctionsAuctionIdRegistrationsCreateRoute,
  };

const ManageAuctionsAuctionIdRegistrationsRouteRouteWithChildren =
  ManageAuctionsAuctionIdRegistrationsRouteRoute._addFileChildren(
    ManageAuctionsAuctionIdRegistrationsRouteRouteChildren,
  );

interface ManageAuctionsAuctionIdRouteRouteChildren {
  ManageAuctionsAuctionIdRegistrationsRouteRoute: typeof ManageAuctionsAuctionIdRegistrationsRouteRouteWithChildren;
  ManageAuctionsAuctionIdRunRouteRoute: typeof ManageAuctionsAuctionIdRunRouteRoute;
  ManageAuctionsAuctionIdEditRoute: typeof ManageAuctionsAuctionIdEditRoute;
  ManageAuctionsAuctionIdRegistrationUrlRoute: typeof ManageAuctionsAuctionIdRegistrationUrlRoute;
}

const ManageAuctionsAuctionIdRouteRouteChildren: ManageAuctionsAuctionIdRouteRouteChildren =
  {
    ManageAuctionsAuctionIdRegistrationsRouteRoute:
      ManageAuctionsAuctionIdRegistrationsRouteRouteWithChildren,
    ManageAuctionsAuctionIdRunRouteRoute: ManageAuctionsAuctionIdRunRouteRoute,
    ManageAuctionsAuctionIdEditRoute: ManageAuctionsAuctionIdEditRoute,
    ManageAuctionsAuctionIdRegistrationUrlRoute:
      ManageAuctionsAuctionIdRegistrationUrlRoute,
  };

const ManageAuctionsAuctionIdRouteRouteWithChildren =
  ManageAuctionsAuctionIdRouteRoute._addFileChildren(
    ManageAuctionsAuctionIdRouteRouteChildren,
  );

interface ManageAuctionsRouteRouteChildren {
  ManageAuctionsAuctionIdRouteRoute: typeof ManageAuctionsAuctionIdRouteRouteWithChildren;
  ManageAuctionsCreateRoute: typeof ManageAuctionsCreateRoute;
}

const ManageAuctionsRouteRouteChildren: ManageAuctionsRouteRouteChildren = {
  ManageAuctionsAuctionIdRouteRoute:
    ManageAuctionsAuctionIdRouteRouteWithChildren,
  ManageAuctionsCreateRoute: ManageAuctionsCreateRoute,
};

const ManageAuctionsRouteRouteWithChildren =
  ManageAuctionsRouteRoute._addFileChildren(ManageAuctionsRouteRouteChildren);

interface ManageReviewsRequestsRouteRouteChildren {
  ManageReviewsRequestsCreateRoute: typeof ManageReviewsRequestsCreateRoute;
}

const ManageReviewsRequestsRouteRouteChildren: ManageReviewsRequestsRouteRouteChildren =
  {
    ManageReviewsRequestsCreateRoute: ManageReviewsRequestsCreateRoute,
  };

const ManageReviewsRequestsRouteRouteWithChildren =
  ManageReviewsRequestsRouteRoute._addFileChildren(
    ManageReviewsRequestsRouteRouteChildren,
  );

interface ManageReviewsRouteRouteChildren {
  ManageReviewsRequestsRouteRoute: typeof ManageReviewsRequestsRouteRouteWithChildren;
  ManageReviewsIndexRoute: typeof ManageReviewsIndexRoute;
}

const ManageReviewsRouteRouteChildren: ManageReviewsRouteRouteChildren = {
  ManageReviewsRequestsRouteRoute: ManageReviewsRequestsRouteRouteWithChildren,
  ManageReviewsIndexRoute: ManageReviewsIndexRoute,
};

const ManageReviewsRouteRouteWithChildren =
  ManageReviewsRouteRoute._addFileChildren(ManageReviewsRouteRouteChildren);

interface ManageRouteRouteChildren {
  ManageAuctionsRouteRoute: typeof ManageAuctionsRouteRouteWithChildren;
  ManageReviewsRouteRoute: typeof ManageReviewsRouteRouteWithChildren;
  ManageIndexRoute: typeof ManageIndexRoute;
}

const ManageRouteRouteChildren: ManageRouteRouteChildren = {
  ManageAuctionsRouteRoute: ManageAuctionsRouteRouteWithChildren,
  ManageReviewsRouteRoute: ManageReviewsRouteRouteWithChildren,
  ManageIndexRoute: ManageIndexRoute,
};

const ManageRouteRouteWithChildren = ManageRouteRoute._addFileChildren(
  ManageRouteRouteChildren,
);

interface RegistrationRouteRouteChildren {
  RegistrationAuctionIdRoute: typeof RegistrationAuctionIdRoute;
}

const RegistrationRouteRouteChildren: RegistrationRouteRouteChildren = {
  RegistrationAuctionIdRoute: RegistrationAuctionIdRoute,
};

const RegistrationRouteRouteWithChildren =
  RegistrationRouteRoute._addFileChildren(RegistrationRouteRouteChildren);

interface ReviewRouteRouteChildren {
  ReviewRequestIdRoute: typeof ReviewRequestIdRoute;
}

const ReviewRouteRouteChildren: ReviewRouteRouteChildren = {
  ReviewRequestIdRoute: ReviewRequestIdRoute,
};

const ReviewRouteRouteWithChildren = ReviewRouteRoute._addFileChildren(
  ReviewRouteRouteChildren,
);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ManageRouteRoute: ManageRouteRouteWithChildren,
  RegistrationRouteRoute: RegistrationRouteRouteWithChildren,
  ReviewRouteRoute: ReviewRouteRouteWithChildren,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
